import { isEqual } from "lodash";

import ChartStreamService from "app/pages/sales-intelligence/modules/ai-agent/services/chart/chartService";
import type { ParsedAIEmailPreview } from "app/pages/sales-intelligence/modules/ai-agent/services/jsonParser/types";

const createEmailPreviewService = () => {
    const areSamePreview = (a?: ParsedAIEmailPreview, b?: ParsedAIEmailPreview): boolean => {
        if (!a || !b) {
            return false;
        }
        const ai = a.chartAnchorIndex ?? -1;
        const bi = b.chartAnchorIndex ?? -1;
        return (
            a.subject === b.subject &&
            a.body === b.body &&
            ai === bi &&
            !!a.chartJson &&
            !!b.chartJson &&
            isEqual(a.chartJson, b.chartJson)
        );
    };

    /**
     * Previews offered as visuals. The list is chart-only, so a preview's identity here is its chart
     * alone: a chart-less preview has nothing to show, and one carrying the applied chart is dropped
     * regardless of its subject and body.
     */
    const getSelectablePreviews = (
        previews?: ParsedAIEmailPreview[],
        appliedChart?: Record<string, unknown> | null,
    ): ParsedAIEmailPreview[] =>
        (previews ?? []).filter(
            (preview) =>
                ChartStreamService.isChartObject(preview.chartJson) && !isEqual(preview.chartJson, appliedChart),
        );

    return {
        areSamePreview,
        getSelectablePreviews,
    };
};

const EmailPreviewService = createEmailPreviewService();

export default EmailPreviewService;
